
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hyderabad",
      function () {
        return require("private-next-pages/hyderabad/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hyderabad"])
      });
    }
  